import { Carousel } from 'react-responsive-carousel';
import classNames from 'classnames';
import { motion } from 'framer-motion';

import { LOGIN_PREVIEW_SLIDES } from 'utils/constants';

import { PreviewCarouselProps } from './previewCarousel.types';

const PreviewCarousel: React.FC<PreviewCarouselProps> = ({ onChange }) => {
  return (
    <motion.div animate={{ opacity: 1 }} className="h-full" initial={{ opacity: 0 }}>
      <Carousel
        className="alt-scroll signup-carousel"
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        infiniteLoop
        onChange={onChange}
      >
        {LOGIN_PREVIEW_SLIDES.map(
          (
            {
              imageUrl,
              title,
              text,
              imageAsBackground = false,
              imageClassName = 'top-[100px]',
              className = 'pt-[80px]'
            },
            i
          ) => (
            <div
              className={classNames(
                'relative flex h-[calc(100dvh_-_140px)] w-screen flex-col items-center p-4',
                className
              )}
              key={i}
              style={{
                background: imageUrl && imageAsBackground ? `url(${imageUrl}) no-repeat` : 'none',
                backgroundPosition: 'top center',
                backgroundSize: '100%'
              }}
            >
              {!imageAsBackground && (
                <img
                  alt="bg-image"
                  className={classNames(
                    'relative z-0 aspect-auto w-full object-contain',
                    imageClassName
                  )}
                  src={imageUrl}
                />
              )}
              <div className="absolute bottom-[46px] flex flex-col items-center justify-center px-4">
                <p className="mb-4 text-mLg font-bold text-white">{title}</p>
                <p
                  className="text-center text-mBase text-white/80"
                  style={{ wordWrap: 'break-word' }}
                >
                  {text}
                </p>
              </div>
            </div>
          )
        )}
      </Carousel>
    </motion.div>
  );
};

export default PreviewCarousel;
